<template>
  <div id="unsubscribe">
    <div class="unsubscribe-content">
      <div class="unsubscribe-logo">
        <!-- <img :src="`${domain}/${publisherInfo.logo}`"
             alt=""> -->
        <svg xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="341.438"
             height="78.483"
             viewBox="0 0 341.438 78.483">
          <defs>
            <linearGradient id="linear-gradient"
                            x1="178.286"
                            y1="2.155"
                            x2="177.491"
                            y2="1.876"
                            gradientUnits="objectBoundingBox">
              <stop offset="0"
                    stop-color="#114a87" />
              <stop offset="0.181"
                    stop-color="#416e9f"
                    stop-opacity="0.82" />
              <stop offset="0.586"
                    stop-color="#a6bbd2"
                    stop-opacity="0.416" />
              <stop offset="0.868"
                    stop-color="#e6ecf2"
                    stop-opacity="0.133" />
              <stop offset="1"
                    stop-color="#fff"
                    stop-opacity="0" />
            </linearGradient>
          </defs>
          <g id="IMR-fullLogo"
             transform="translate(-33.4 -16.6)">
            <g id="Group_5"
               data-name="Group 5"
               transform="translate(33.4 16.6)">
              <path id="Path_10"
                    data-name="Path 10"
                    d="M336.2,421.518l-1.754-1.68A43.469,43.469,0,0,0,329.837,416a44.413,44.413,0,0,0-4.609,3.838l-1.763,1.671-.165,18.225a40.63,40.63,0,0,1,6.528,3.14,40.633,40.633,0,0,1,6.528-3.14Zm-6.427,13.12-2.259-6.51,2.259-2.543,2.259,2.543Z"
                    transform="translate(-296.683 -379.329)"
                    fill="#114a87" />
              <path id="Path_13"
                    data-name="Path 13"
                    d="M41.149,42.143a46.612,46.612,0,0,1,7.005.5V32.64L67.38,21.54l19.226,11.1v4.839c-.937.083-1.873.193-2.8.331V34.265L67.38,24.771,50.955,34.256v8.9a45.777,45.777,0,0,1,15.59,6.5,45.942,45.942,0,0,1,25.249-7.51h9.567V36.221L67.38,16.6,33.4,36.221v5.913h7.749Z"
                    transform="translate(-33.4 -16.6)"
                    fill="#114a87" />
              <path id="Path_14"
                    data-name="Path 14"
                    d="M428.438,713.922l-.046-5.022a36.83,36.83,0,0,0-3.792,1.818A37.78,37.78,0,0,1,428.438,713.922Z"
                    transform="translate(-388.682 -645.337)"
                    fill="#114a87" />
              <path id="Path_15"
                    data-name="Path 15"
                    d="M322.546,708.9l-.046,5.022a37.943,37.943,0,0,1,3.838-3.2A36.8,36.8,0,0,0,322.546,708.9Z"
                    transform="translate(-295.956 -645.337)"
                    fill="#114a87" />
              <path id="Path_16"
                    data-name="Path 16"
                    d="M41.3,327.2H33.4v30.354l23.532,13.589.092-9.971a51.2,51.2,0,0,0-15.406-2.277c-.11,0-.211-.009-.321-.009H39.662l-.009-2.837-.046-23.853h2.975l.055,23.725A55.774,55.774,0,0,1,57.051,358.1l.147-16.6.009-1.864.34-.34a.585.585,0,0,1,.119-.138l2.213-2.112a44.719,44.719,0,0,1,4.04-3.443A42.926,42.926,0,0,0,41.3,327.2Z"
                    transform="translate(-33.4 -298.682)"
                    fill="#114a87" />
              <path id="Path_18"
                    data-name="Path 18"
                    d="M397.126,396.8a25.931,25.931,0,0,0-2.626,1.754s1.873,1.414,2.516,1.965l1.074-2.966C398.081,397.553,397.466,397.057,397.126,396.8Z"
                    transform="translate(-361.346 -361.892)"
                    opacity="0.46"
                    fill="url(#linear-gradient)" />
              <path id="Path_23"
                    data-name="Path 23"
                    d="M445.861,327.2h-.138a43,43,0,0,0-22.623,6.39,46.254,46.254,0,0,1,4.04,3.443l1.7,1.625h0l.514.5-.009.009c.009.009.028.009.037.018a.9.9,0,0,1,.11.138l.321.321v1.478h0l.156,16.976a56.572,56.572,0,0,1,14.415-2.176l-.055-23.725H447.3l.055,26.69h-1.625c-.413,0-.817.009-1.221.018A50.5,50.5,0,0,0,430,361.162l.1,10.935h0l25.2-14.553V327.2Z"
                    transform="translate(-387.32 -298.682)"
                    fill="#114a87" />
              <path id="Path_24"
                    data-name="Path 24"
                    d="M326.865,754.261l-3.6-3.443a34.35,34.35,0,0,0-4.609-3.718,35.7,35.7,0,0,0-4.609,3.718L311,753.609l8.493,4.9,7.373-4.251Z"
                    transform="translate(-285.512 -680.03)"
                    fill="#114a87" />
            </g>
            <g id="Group_2"
               data-name="Group 2"
               transform="translate(111.644 25.551)">
              <path id="Path_2"
                    data-name="Path 2"
                    d="M885.6,160.816V117.7h9.145v43.125H885.6Z"
                    transform="translate(-885.6 -117.7)"
                    fill="#114a87" />
              <path id="Path_3"
                    data-name="Path 3"
                    d="M1090.762,160.816l-10.384-33.834h-.266q.565,10.329.56,13.772v20.061H1072.5V117.7h12.45l10.21,32.98h.174l10.825-32.98h12.45v43.125h-8.521V140.406c0-.964.018-2.075.046-3.333s.165-4.6.395-10.026h-.266l-11.119,33.769Z"
                    transform="translate(-1055.34 -117.7)"
                    fill="#114a87" />
              <path id="Path_4"
                    data-name="Path 4"
                    d="M1671.045,144.271v16.545H1661.9V117.7h12.569q8.787,0,13.01,3.2t4.214,9.723a11.438,11.438,0,0,1-2.093,6.767,13.842,13.842,0,0,1-5.931,4.646q9.737,14.543,12.68,18.785H1686.2l-10.292-16.545h-4.866Zm0-7.428h2.947q4.339,0,6.4-1.441a5.162,5.162,0,0,0,2.066-4.545,4.711,4.711,0,0,0-2.112-4.361q-2.108-1.295-6.537-1.295h-2.773v11.642Z"
                    transform="translate(-1590.624 -117.7)"
                    fill="#114a87" />
              <path id="Path_5"
                    data-name="Path 5"
                    d="M2235.094,131.142q0,6.955-4.352,10.65t-12.376,3.691h-3.921v15.342H2205.3V117.7h13.772q7.85,0,11.927,3.379Q2235.1,124.453,2235.094,131.142Zm-20.65,6.849h3.012q4.214,0,6.317-1.662a5.834,5.834,0,0,0,2.093-4.857,5.99,5.99,0,0,0-1.753-4.747c-1.175-1.019-3-1.533-5.5-1.533h-4.159v12.8Z"
                    transform="translate(-2084.132 -117.7)"
                    fill="#114a87" />
              <path id="Path_6"
                    data-name="Path 6"
                    d="M2598.208,221.4a14.679,14.679,0,0,1,3.039.266l-.679,8.438a10.481,10.481,0,0,0-2.653-.294,9.532,9.532,0,0,0-6.712,2.213,7.985,7.985,0,0,0-2.405,6.2V255h-9v-32.98h6.813l1.332,5.546h.44a12.43,12.43,0,0,1,4.141-4.471A10.253,10.253,0,0,1,2598.208,221.4Z"
                    transform="translate(-2424.249 -211.879)"
                    fill="#114a87" />
              <path id="Path_7"
                    data-name="Path 7"
                    d="M2842.73,255.592q-7.96,0-12.45-4.4t-4.48-12.45q0-8.291,4.141-12.817T2841.4,221.4q7,0,10.88,3.985t3.893,11v4.361h-21.265a8.678,8.678,0,0,0,2.268,5.986,8.007,8.007,0,0,0,5.958,2.148,24.287,24.287,0,0,0,5.638-.624,28.482,28.482,0,0,0,5.545-1.974v6.96a20.992,20.992,0,0,1-5.041,1.754A30.191,30.191,0,0,1,2842.73,255.592Zm-1.267-27.792a5.679,5.679,0,0,0-4.48,1.818,8.391,8.391,0,0,0-1.855,5.151h12.625a7.548,7.548,0,0,0-1.735-5.151A5.921,5.921,0,0,0,2841.463,227.8Z"
                    transform="translate(-2647.662 -211.879)"
                    fill="#114a87" />
              <path id="Path_8"
                    data-name="Path 8"
                    d="M3208.528,245.208a9.09,9.09,0,0,1-3.525,7.731q-3.526,2.658-10.55,2.653a33.368,33.368,0,0,1-6.133-.487,22.666,22.666,0,0,1-4.747-1.432v-7.437a31.231,31.231,0,0,0,5.647,1.974,22.807,22.807,0,0,0,5.527.8c3.268,0,4.893-.946,4.893-2.828a2.37,2.37,0,0,0-.652-1.726,9.522,9.522,0,0,0-2.24-1.506q-1.6-.84-4.251-1.965a27.261,27.261,0,0,1-5.591-2.947,8.269,8.269,0,0,1-2.6-3.112,10.242,10.242,0,0,1-.808-4.324,7.827,7.827,0,0,1,3.407-6.794q3.4-2.41,9.658-2.406a27.316,27.316,0,0,1,11.587,2.6l-2.718,6.491q-2.479-1.061-4.627-1.744a14.614,14.614,0,0,0-4.4-.679q-3.98,0-3.985,2.158a2.531,2.531,0,0,0,1.286,2.093,34.61,34.61,0,0,0,5.619,2.626,26.534,26.534,0,0,1,5.665,2.92,8.579,8.579,0,0,1,2.654,3.122A9.281,9.281,0,0,1,3208.528,245.208Z"
                    transform="translate(-2972.52 -211.879)"
                    fill="#114a87" />
              <path id="Path_9"
                    data-name="Path 9"
                    d="M3504.628,245.208a9.092,9.092,0,0,1-3.525,7.731q-3.527,2.658-10.55,2.653a33.38,33.38,0,0,1-6.133-.487,22.67,22.67,0,0,1-4.747-1.432v-7.437a31.231,31.231,0,0,0,5.647,1.974,22.8,22.8,0,0,0,5.527.8c3.269,0,4.894-.946,4.894-2.828a2.37,2.37,0,0,0-.652-1.726,9.541,9.541,0,0,0-2.24-1.506q-1.6-.84-4.25-1.965a27.294,27.294,0,0,1-5.592-2.947,8.279,8.279,0,0,1-2.6-3.112,10.247,10.247,0,0,1-.807-4.324,7.828,7.828,0,0,1,3.406-6.794q3.4-2.41,9.659-2.406a27.313,27.313,0,0,1,11.587,2.6l-2.718,6.491q-2.48-1.061-4.627-1.744a14.612,14.612,0,0,0-4.4-.679q-3.98,0-3.984,2.158a2.53,2.53,0,0,0,1.285,2.093,34.656,34.656,0,0,0,5.62,2.626,26.571,26.571,0,0,1,5.665,2.92,8.582,8.582,0,0,1,2.653,3.122A9.278,9.278,0,0,1,3504.628,245.208Z"
                    transform="translate(-3241.434 -211.879)"
                    fill="#114a87" />
            </g>
            <text id="Connecting_Today_s_Knowledge_to_the_future."
                  data-name="Connecting Today’s Knowledge to the future."
                  transform="translate(110.132 86.005)"
                  fill="#114a87"
                  font-size="11"
                  font-family="OpenSans-Semibold, Open Sans"
                  font-weight="600"
                  letter-spacing="0.05em">
              <tspan x="0"
                     y="0">Connecting Today’s Knowledge to the future.</tspan>
            </text>
          </g>
        </svg>
      </div>
      <div class="ipub-block ipub-shadow tc mar-b-30"
           style="padding:50px;min-height: 600px;box-sizing:border-box">
        <template v-if="!result">
          <div class="ipub-h1 mar-b-8"
               style="font-size: 40px">Unsubscribe</div>
          <div class="ipub-p2 mar-b-40"
               style="font-size: 20px">We’re so sorry to see you go!</div>
          <div class="mar-b-20">
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="212"
                 height="212"
                 viewBox="0 0 212 212">
              <g id="Group_1523"
                 data-name="Group 1523"
                 transform="translate(-112.329 -200.579)">
                <circle id="Ellipse_12"
                        data-name="Ellipse 12"
                        cx="106"
                        cy="106"
                        r="106"
                        transform="translate(112.329 200.579)"
                        fill="#526475" />
                <g id="Group_1520"
                   data-name="Group 1520"
                   transform="translate(155.447 237.136)">
                  <path id="Path_1069"
                        data-name="Path 1069"
                        d="M277.514,285.946,214.632,234,151.75,285.946Z"
                        transform="translate(-151.75 -234)"
                        fill="#c5ccce" />
                  <path id="Path_1070"
                        data-name="Path 1070"
                        d="M270.354,281.5l-42.1,34.448,40.623,40.623.558-.121a7.314,7.314,0,0,0,.923-3.562Z"
                        transform="translate(-144.59 -229.554)"
                        fill="#fdfdfd" />
                  <path id="Path_1071"
                        data-name="Path 1071"
                        d="M193.854,315.948,151.75,281.5v71.388a7.314,7.314,0,0,0,.923,3.562l.558.121Z"
                        transform="translate(-151.75 -229.554)"
                        fill="#fdfdfd" />
                  <path id="Path_1072"
                        data-name="Path 1072"
                        d="M235.41,315.948l42.1-34.448H151.75l42.1,34.448-40.623,40.623-.558-.121a7.356,7.356,0,0,0,4.653,3.561l-.552-.518,40.859-40.858,12.877,12.877a5.057,5.057,0,0,0,7.15,0l13.376-13.376,41.643,41.643a7.362,7.362,0,0,0,3.912-3.329l-.558.121Z"
                        transform="translate(-151.75 -229.554)"
                        fill="#a3a9ab" />
                  <path id="Path_1073"
                        data-name="Path 1073"
                        d="M217.23,328.376a5.057,5.057,0,0,1-7.15,0L197.2,315.5l-40.859,40.858.552.518a7.308,7.308,0,0,0,1.775.229H269.733a7.276,7.276,0,0,0,2.516-.46L230.606,315Z"
                        transform="translate(-151.32 -226.418)"
                        fill="#fdfdfd" />
                </g>
                <circle id="Ellipse_13"
                        data-name="Ellipse 13"
                        cx="18.997"
                        cy="18.997"
                        r="18.997"
                        transform="translate(199.058 269.537)"
                        fill="#526475" />
                <g id="Group_1521"
                   data-name="Group 1521"
                   transform="translate(197.277 267.756)">
                  <path id="Path_1074"
                        data-name="Path 1074"
                        d="M210.778,303.557a20.778,20.778,0,1,1,20.778-20.778A20.8,20.8,0,0,1,210.778,303.557Zm0-37.995a17.217,17.217,0,1,0,17.217,17.217A17.237,17.237,0,0,0,210.778,265.562Z"
                        transform="translate(-190 -262)"
                        fill="#fdfdfd" />
                </g>
                <g id="Group_1522"
                   data-name="Group 1522"
                   transform="translate(202.695 274.208)">
                  <rect id="Rectangle_294"
                        data-name="Rectangle 294"
                        width="3.562"
                        height="38.103"
                        transform="matrix(0.707, -0.707, 0.707, 0.707, 0, 2.518)"
                        fill="#fdfdfd" />
                </g>
              </g>
            </svg>
          </div>
          <div class="ipub-p2 mar-b-20"
               style="font-size:24px;line-height: 32px">
            Are you sure you wish to unsubscribe all update emails from the {{journalInfo.fullName}}?</div>
          <div>
            <ipub-button type="primary"
                         @click="goToPage"
                         style="width:200px">No</ipub-button>
            <ipub-button type="primary"
                         @click="submit(false)"
                         style="width:200px"
                         plain>Yes</ipub-button>
          </div>
        </template>
        <template v-else>
          <div class="tc success-color"
               style="font-size: 100px; margin-top:110px;height:100px">
            <ipub-icon type="iconAble" />
          </div>
          <div class="ipubw-h1 mar-b-16">Your unsubscribe is successfully</div>
          <div class="ipub-p2"
               style="font-size:24px;line-height:32px;">
            If you decide you want to hear from us again in the future, you can always <a class="link-color"
               @click="submit(true)">subscribe again</a>
          </div>
        </template>
      </div>
      <div class="tc"
           style="font-size: 14px;font-weight: 600;">{{journalInfo.fullName}} (<i>{{journalInfo.name}}</i>) Print ISSN: {{journalInfo.issn}} | Electronic ISSN: {{journalInfo.eissn}}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
